import { FC } from 'react';

import {
  OrderedList,
  SectionLink,
  StyledButton,
  UnorderedList,
} from '@/_pages/interwill/instructions/components/styled';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { Section, SectionType } from '../types';

type ContentProps = {
  section: Section;
};

export const SectionContent: FC<ContentProps> = ({ section }) => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'instructions' });

  let content = <p>{t.rich(`${section.key}.content`)}</p>;

  if (section.type === SectionType.LIST) {
    const { itemsCount, isUnordered } = section;
    const List = isUnordered ? UnorderedList : OrderedList;

    content = (
      <List>
        {Array.from({ length: itemsCount }).map((_, index) => (
          <li key={index}>{t.rich(`${section.key}.items.${index}`)}</li>
        ))}
      </List>
    );
  }

  return (
    <>
      {content}
      {section.link && (
        <SectionLink href={section.link} target="_blank">
          {t(`${section.key}.link`)}
        </SectionLink>
      )}
      {section.hasNote && <p>{t.rich(`${section.key}.note`)}</p>}
      {section.buttonAction && (
        <StyledButton type="default" onClick={section.buttonAction}>
          {t(`${section.key}.button`)}
        </StyledButton>
      )}
    </>
  );
};
